
import { defineComponent, computed, ref, watch, reactive, toRefs } from 'vue'
import ForCon from '@/views/pageAll/forCon.vue'
import Page from '@/views/pageAll/content.vue'
import { useRoute } from 'vue-router'
import { RightOutlined, DownOutlined } from '@ant-design/icons-vue'
export default defineComponent({
  name: 'ForCon',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    ForCon,
    Page,
    RightOutlined,
    DownOutlined
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: []
    })
    pageData.data = props.data
    return {
      ...toRefs(pageData)
    }
  }
})
